const url = process.env.REACT_APP_HOST_SRV_DOMAIN;
const urlExpediente = url + "/expedientes";
const urlNote = url + "/note";
const urlDate = url + "/date";
const urlTime = url + "/time";
const urlDocument = url + "/document";
const urlTemplate = url + "/template";
const urlAuth = url + "/login";
const urlTask = url + "/task";
const urlReporting = url + "/reporting";

const Services = {
  urlExpediente,
  urlNote,
  urlDate,
  urlTime,
  urlDocument,
  urlTemplate,
  urlAuth,
  urlTask,
  urlReporting
};

export default Services;
